<h1 mat-dialog-title class="text-center pm-dialog-title mb-2">
  {{ isBatch ? ('Language.BatchOutPopupText' | translate) : ('Language.SerialOutPopupText' | translate)}}
</h1>
<div mat-dialog-content class="contentt" >

    <div class="row" style=" position: sticky; 
    top: 0;
    z-index: 10; background-color:white;">
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" [ngModel]="this.local_data.itemCode" 
                matInput name="ItemCode" placeholder="Item Code" readonly="true">
            </mat-form-field>
        </div>
        <div class="col-4">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput [ngModel]="this.local_data.itemDescription"
                name="ItemName" placeholder="Item Name" readonly="true">
            </mat-form-field>
        </div>
       
        <div class="col-2" *ngIf="inventoryTransfer">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput name="warehouseName" readonly="true"
                placeholder="Warehouse Name" [ngModel]="this.local_data.fromWarehouseCodeName">
            </mat-form-field>
        </div>
        <div class="col-2" *ngIf="inventoryTransfer">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="warehouseName" readonly="true"
              placeholder="Warehouse Name" [ngModel]="this.local_data.warehouseCodeName">
          </mat-form-field>
      </div>
      
      <div class="col-4" *ngIf="!inventoryTransfer">
        <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="warehouseName" readonly="true"
            placeholder="Warehouse Name" [ngModel]="this.local_data.warehouseName">
        </mat-form-field>
    </div>
        
        <div class="col-6">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
                <input type="text" matInput name="totalQty" readonly="true"
                placeholder="Total Qty" [ngModel]="this.availableQuantity">
            </mat-form-field>
        </div>
        <div class="col-6">
            <div class="d-flex align-items-center">
                <mat-form-field class="w-100 field-bottom-0 me-2" appearance="outline">
                    <input type="text" matInput       [(ngModel)]="code"  name="findWithBatch" [placeholder]=" 'Find With ' + (isBatch==true ? 'Batch' : 'Serial') ">
                </mat-form-field>
                <button mat-raised-button color="primary"   (click)="filterData()">{{'Language.FindText' | translate}}</button>
            </div>
        </div>
    </div>
    <div class="table-design">
     
    <table mat-table class="table-design" [dataSource]="this.getListViewDataSource" *ngIf="!inventoryTransfer">
      
      <div style=" position: sticky !important;
      top: 0 !important;
      z-index: 100 !important; background-color:white;"><ng-container matColumnDef="checkbox">
        <th mat-header-cell *matHeaderCellDef  sticky style=" position: sticky !important;
        top: 0 !important;
        z-index: 100 !important; background-color:white;">
           Select {{ isBatch ? ('Language.BatchText' | translate) : ('Language.SerialText' | translate) }}
        </th>
        <td mat-cell *matCellDef="let element; let i = index" class="app-vf-td-mat-cell" >
          <div class="text-center">
            <mat-checkbox value="element" 
            [disabled]="this.local_data.isViewMode"
            [ngModel]="element.isChecked"
            (change)="selectBatchSerial($event,i)"
            color="primary"></mat-checkbox>
          </div>
        </td>
      </ng-container>
      </div>
      <ng-container matColumnDef="serialNo">
        <th mat-header-cell *matHeaderCellDef sticky style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.S.No.Text' | translate }}
        </th>
        <td *matCellDef="let element;let i=index">
          <div class="text-center">
            {{i + 1}}
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="BatchNo">
        <th mat-header-cell *matHeaderCellDef style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{ isBatch ? ('Language.BatchNumberText' | translate ) : ('Language.SerialNoText' | translate ) }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="BatchNo" disabled
            [ngModel]="element.batchSerialNumber || element.batchNumber" placeholder="{{ isBatch ? 'Batch No.' : 'Serial No.' }}">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="Quantity">
        <th mat-header-cell *matHeaderCellDef style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.QuantityBatchText' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="quantity" disabled
            [ngModel]="element.quantity" placeholder="Quantity">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="enterQuantity">
        <th mat-header-cell *matHeaderCellDef [hidden]="this.local_data.isViewMode" style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.EnterQuantityText' | translate}}
        </th>
        <td mat-cell *matCellDef="let element; let i = index" [hidden]="this.local_data.isViewMode">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput #qtyEl min="1" [ngModel]="element.onHandQty"
            name="enterQuantity" (input)="validateAndUpdateQty(qtyEl, i)"
            [disabled]="!element.isChecked || this.local_data.isViewMode" placeholder="Enter Quantity">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="binLocationAllocation">
        <th mat-header-cell *matHeaderCellDef hidden style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.BinLocationAllocationText'| translate}}  
        </th>
        <td mat-cell *matCellDef="let element" hidden>
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="binLocationAllocation" placeholder="Bin Location Allocation" disabled>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="sysNumber">
        <th mat-header-cell *matHeaderCellDef hidden style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.SysNumberText' | translate}}     
        </th>
        <td mat-cell *matCellDef="let element" hidden>
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="sysNumber" disabled
            [ngModel]="element.systemSerialNumber" placeholder="Sys Number">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="intSerialNumber">
        <th mat-header-cell *matHeaderCellDef style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.InternalSerialNumberText' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="intSerialNumber" disabled
            [ngModel]="element.internalSerialNumber" placeholder="Internal Serial Number">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="mfrSerialNumber">
        <th mat-header-cell *matHeaderCellDef style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.ManufacturingSerialNoText' | translate }}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field class="w-100 field-bottom-0" appearance="outline">
            <input type="text" matInput name="mfrSerialNumber" disabled
            [ngModel]="element.manufacturerSerialNumber" placeholder="Manufacturer Serial Number">
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="expiryDate">
        <th mat-header-cell *matHeaderCellDef style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.ExpirationDateText' | translate}}
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="outline" class="w-100 field-bottom-0">
            <input [matDatepicker]="ExpiraitonDate" required type="text"
                [(ngModel)]="element.expiryDate" disabled="true"
                matInput readonly (click)="ExpiraitonDate.open()" name="ExpiraitonDate"
                placeholder="Expiry Date" />
            <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
            </mat-datepicker-toggle>
            <mat-datepicker #ExpiraitonDate>
            </mat-datepicker>
          </mat-form-field>
        </td>
      </ng-container>
      <ng-container matColumnDef="mfrDate">
        <th mat-header-cell *matHeaderCellDef style=" position: sticky;
        top: 0;
        z-index: 10; background-color:white;">
          {{'Language.ManufacturingDateText' | translate}} 
        </th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="outline" class="w-100 field-bottom-0">
            <input [matDatepicker]="ManufacturingDate" required type="text"
                [(ngModel)]="element.manufacturingDate" disabled="true"
                matInput readonly (click)="ManufacturingDate.open()" name="ManufacturingDate"
                placeholder="Manufacturing Date" />
            <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
            </mat-datepicker-toggle>
            <mat-datepicker #ManufacturingDate>
            </mat-datepicker>
        </mat-form-field>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList;sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
    </table>
    <table mat-table [dataSource]="this.getListViewDataSource" *ngIf="inventoryTransfer && !this.local_data.isViewMode">
        <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef>
             Select {{ isBatch ? ('Language.BatchText' | translate) : ('Language.SerialText' | translate) }}
          </th>
          <td mat-cell *matCellDef="let element; let i = index" class="app-vf-td-mat-cell">
            <div class="text-center">
              <mat-checkbox value="element" 
              [disabled]="this.local_data.isViewMode"
              [ngModel]="element.isChecked"
              (change)="selectBatchSerial($event,i)"
              color="primary"></mat-checkbox>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="serialNo">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.S.No.Text' | translate }}
          </th>
          <td *matCellDef="let element;let i=index">
            <div class="text-center">
              {{i + 1}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="BatchNo">
          <th mat-header-cell *matHeaderCellDef>
            {{ isBatch ? ('Language.BatchNumberText' | translate ) : ('Language.SerialNoText' | translate ) }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="BatchNo" disabled
              [ngModel]="element.batchSerialNumber || element.batchNumber" placeholder="{{ isBatch ? 'Batch No.' : 'Serial No.' }}">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="Quantity">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.QuantityBatchText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="quantity" disabled
              [ngModel]="element.quantity" placeholder="Quantity">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="enterQuantity">
          <th mat-header-cell *matHeaderCellDef [hidden]="this.local_data.isViewMode">
            {{'Language.EnterQuantityText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element; let i = index" [hidden]="this.local_data.isViewMode">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput #qtyEl min="1" [ngModel]="element.onHandQty"
              name="enterQuantity" (input)="validateAndUpdateQty(qtyEl, i)"
              [disabled]="!element.isChecked || this.local_data.isViewMode" placeholder="Enter Quantity">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="binLocationAllocation">
          <th mat-header-cell *matHeaderCellDef hidden>
            {{'Language.BinLocationAllocationText'| translate}}  
          </th>
          <td mat-cell *matCellDef="let element" hidden>
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="binLocationAllocation" placeholder="Bin Location Allocation" disabled>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="sysNumber">
          <th mat-header-cell *matHeaderCellDef hidden>
            {{'Language.SysNumberText' | translate}}     
          </th>
          <td mat-cell *matCellDef="let element" hidden>
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="sysNumber" disabled
              [ngModel]="element.systemSerialNumber" placeholder="Sys Number">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="intSerialNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.InternalSerialNumberText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="intSerialNumber" disabled
              [ngModel]="element.internalSerialNumber" placeholder="Internal Serial Number">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="mfrSerialNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.ManufacturingSerialNoText' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="mfrSerialNumber" disabled
              [ngModel]="element.manufacturerSerialNumber" placeholder="Manufacturer Serial Number">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="expiryDate">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.ExpirationDateText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
              <input [matDatepicker]="ExpiraitonDate" required type="text"
                  [(ngModel)]="element.expiryDate" disabled="true"
                  matInput readonly (click)="ExpiraitonDate.open()" name="ExpiraitonDate"
                  placeholder="Expiry Date" />
              <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
              </mat-datepicker-toggle>
              <mat-datepicker #ExpiraitonDate>
              </mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="mfrDate">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.ManufacturingDateText' | translate}} 
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
              <input [matDatepicker]="ManufacturingDate" required type="text"
                  [(ngModel)]="element.manufacturingDate" disabled="true"
                  matInput readonly (click)="ManufacturingDate.open()" name="ManufacturingDate"
                  placeholder="Manufacturing Date" />
              <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
              </mat-datepicker-toggle>
              <mat-datepicker #ManufacturingDate>
              </mat-datepicker>
          </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList;sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
      </table>

      <table mat-table [dataSource]="this.getListViewDataSource" *ngIf="inventoryTransfer && local_data.isViewMode">
        <!-- <ng-container matColumnDef="checkbox">
          <th mat-header-cell *matHeaderCellDef>
             Select {{ isBatch ? 'Batch' : 'Serial' }}
          </th>
          <td mat-cell *matCellDef="let element; let i = index" class="app-vf-td-mat-cell">
            <div class="text-center">
              <mat-checkbox value="element" 
              [disabled]="this.local_data.isViewMode"
              [ngModel]="element.isChecked"
              (change)="selectBatchSerial($event,i)"
              color="primary"></mat-checkbox>
            </div>
          </td>
        </ng-container> -->
        <ng-container matColumnDef="serialNo">
          <th mat-header-cell *matHeaderCellDef>
           {{'Language.S.No.Text' | translate }}
          </th>
          <td *matCellDef="let element;let i=index">
            <div class="text-center">
              {{i + 1}}
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="BatchNo">
          <th mat-header-cell *matHeaderCellDef>
            {{ isBatch ? ('Language.BatchNumberText' | translate ) : ('Language.SerialNoText' | translate ) }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="BatchNo" disabled
              [ngModel]="element.batchSerialNumber" placeholder="Quantity">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="FromQuantity">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.FromQuantityText'| translate}}   
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="quantity" disabled
              [ngModel]="element.fromWarehouseQty" placeholder="Quantity">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="ToQuantity" >
          <th mat-header-cell *matHeaderCellDef >
            {{'Language.ToQuantityText'| translate}}  
          </th>
          <td mat-cell *matCellDef="let element; let i = index">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="quantity" disabled
              [ngModel]="element.toWarehouseQty" placeholder="Quantity">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="binLocationAllocation">
          <th mat-header-cell *matHeaderCellDef hidden>
          {{'Language.BinLocationAllocationText'| translate}} 
          </th>
          <td mat-cell *matCellDef="let element" hidden>
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="binLocationAllocation" placeholder="Bin Location Allocation" disabled>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="sysNumber">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.SysNumberText' | translate}}   
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="sysNumber" disabled
              [ngModel]="element.systemSerialNumber" placeholder="Quantity">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="intSerialNumber">
          <th mat-header-cell *matHeaderCellDef>
           {{'Language.InternalSerialNumberText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="intSerialNumber" disabled
              [ngModel]="element.internalSerialNumber" placeholder="Internal Serial Number">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="mfrSerialNumber">
          <th mat-header-cell *matHeaderCellDef>
           {{'Language.ManufacturingSerialNoText' | translate }}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field class="w-100 field-bottom-0" appearance="outline">
              <input type="text" matInput name="mfrSerialNumber" disabled
              [ngModel]="element.manufacturerSerialNumber" placeholder="Manufacturer Serial Number">
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="expiryDate">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.ExpirationDateText' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
              <input [matDatepicker]="ExpiraitonDate" required type="text"
                  [(ngModel)]="element.expiryDate" disabled="true"
                  matInput readonly (click)="ExpiraitonDate.open()" name="ExpiraitonDate"
                  placeholder="Expiry Date" />
              <mat-datepicker-toggle matSuffix [for]="ExpiraitonDate">
              </mat-datepicker-toggle>
              <mat-datepicker #ExpiraitonDate>
              </mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>
        <ng-container matColumnDef="mfrDate">
          <th mat-header-cell *matHeaderCellDef>
            {{'Language.ManufacturingDateText' | translate}} 
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-form-field appearance="outline" class="w-100 field-bottom-0">
              <input [matDatepicker]="ManufacturingDate" required type="text"
                  [(ngModel)]="element.manufacturingDate" disabled="true"
                  matInput readonly (click)="ManufacturingDate.open()" name="ManufacturingDate"
                  placeholder="Manufacturing Date" />
              <mat-datepicker-toggle matSuffix [for]="ManufacturingDate">
              </mat-datepicker-toggle>
              <mat-datepicker #ManufacturingDate>
              </mat-datepicker>
          </mat-form-field>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList;sticky:true"></tr>
        <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
      </table>
      </div>
</div>
<div class="d-flex justify-content-between">
    <div mat-dialog-actions align="start" class="ps-4">
        <button mat-raised-button color="primary" [disabled]="this.local_data.isViewMode"
        (click)="this.isBatch ? autoSelectBatch() : autoSelectSerial()">
        <mat-icon>edit</mat-icon>
        {{'Language.AutoSelectText' | translate}}  
        </button>
    </div>
    <div mat-dialog-actions align="end">
        <button mat-raised-button color="primary" [disabled]="this.local_data.isViewMode" (click)="saveBatchSerial()">
          {{'Language.SaveText' | translate}}  
        </button>
        <button mat-raised-button mat-dialog-close>
          {{'Language.CancelText' | translate}}  
        </button>
    </div>
</div> 